import React from 'react';
import {
  AddUserProductConnectorApollo,
  UploadImageConnectorApollo,
} from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerAddUserProductContainer from './TrackerAddUserProductContainer';

const TrackerAddUserProductPage: React.FC = () => {
  const location = useLocation();

  return (
    <AddUserProductConnectorApollo>
      {({ addUserProduct }) => (
        <UploadImageConnectorApollo>
          {({ uploadImage }) => (
            <TrackerAddUserProductContainer
              addUserProduct={addUserProduct}
              uploadImage={uploadImage}
              key={location.key}
            />
          )}
        </UploadImageConnectorApollo>
      )}
    </AddUserProductConnectorApollo>
  );
};

export default TrackerAddUserProductPage;
